/**
 * "Zamówienia" My Account tab (Figma node 71:3555) — client-side sortable
 * table (click a column header to sort, click again to reverse).
 */

import './index.scss';

const table = document.querySelector('[data-order-table]');

if (table) {
	const tbody = table.querySelector('tbody');
	const sortButtons = table.querySelectorAll('[data-order-sort]');

	// Default sort — newest first — matches the underlying wc_get_orders()
	// query order, so the ▾ indicator starts on the right column without an
	// extra click.
	let activeSort = { key: 'date', direction: 'desc' };

	const columnType = {
		number: 'text',
		date: 'number',
		value: 'number',
		status: 'text',
	};

	const applySort = () => {
		const rows = Array.from(tbody.querySelectorAll('[data-order-row]'));
		const { key, direction } = activeSort;
		const isText = columnType[key] === 'text';
		const multiplier = direction === 'asc' ? 1 : -1;

		rows.sort((a, b) => {
			const rawA = a.dataset[key];
			const rawB = b.dataset[key];
			const valueA = isText ? rawA.toLowerCase() : parseFloat(rawA);
			const valueB = isText ? rawB.toLowerCase() : parseFloat(rawB);

			if (valueA < valueB) return -1 * multiplier;
			if (valueA > valueB) return 1 * multiplier;
			return 0;
		});

		rows.forEach((row) => tbody.appendChild(row));

		sortButtons.forEach((btn) => {
			const isActive = btn.dataset.orderSort === key;
			btn.classList.toggle('is-active', isActive);
			btn.classList.toggle('is-desc', isActive && direction === 'desc');
		});
	};

	sortButtons.forEach((button) => {
		button.addEventListener('click', () => {
			const key = button.dataset.orderSort;
			const direction =
				activeSort.key === key && activeSort.direction === 'desc' ? 'asc' : 'desc';

			activeSort = { key, direction };
			applySort();
		});
	});

	applySort();
}
